import { render } from "./ButtonClickStatistics.vue?vue&type=template&id=7be4aaba&scoped=true"
import script from "./ButtonClickStatistics.vue?vue&type=script&lang=js"
export * from "./ButtonClickStatistics.vue?vue&type=script&lang=js"

import "./ButtonClickStatistics.vue?vue&type=style&index=0&id=7be4aaba&lang=scss&scoped=true"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be4aaba"]])

export default __exports__